<script>
  import { onMount } from 'svelte'
  import Letterchar from './Letterchar.svelte'
  import { getGravaterUrl } from '../../utils'
  import { checkGravatarStatus } from '../../api'
  export let reviewerImage
  export let reviewerName
  export let reviewerEmail
  export let profileBackground = '#7A8998'
  export let float

  let gravatarExist
  let gravatarUrl

  onMount(async () => {
    if (!reviewerImage && reviewerEmail) {
      gravatarUrl = getGravaterUrl(reviewerEmail)
      gravatarExist = await checkGravatarStatus(gravatarUrl)
    }
  })
</script>

<style>
  :global(.reviewer-image-wrapper-1BN6De) {
    display: block;
    line-height: 45px;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    margin-right: 10px;
  }

  :global(.reviewer-image-wrapper-1BN6De) img {
    width: 45px;
    border-radius: 50%;
  }
</style>

<div class="reviewer-image-wrapper-1BN6De" style="float: {float};">
  {#if reviewerImage && reviewerImage !== null}
    <img class="" alt="reviewer" src={reviewerImage} />
  {:else if gravatarExist}
    <img class="" alt="reviewer" src={gravatarUrl} />
  {:else if reviewerName}
    <Letterchar {reviewerName} {profileBackground} />
  {/if}
</div>
